import { Link } from "react-router-dom";
import { fmtCurrency, fmtDateLong } from "@/lib/format";
import { QUOTE_STATUS } from "@/lib/sales";
import { PenLine } from "lucide-react";
import { StatusBadge } from "@/components/common/ui-kit";

export const QuoteRows = ({ quotes, empty = "Nessuna offerta." }) => (
  quotes.length === 0 ? <p className="text-sm text-slate-500" data-testid="quote-rows-empty">{empty}</p> : (
    <ul className="divide-y divide-slate-100" data-testid="quote-rows">
      {quotes.map((q) => {
        const st = QUOTE_STATUS[q.status] || QUOTE_STATUS.bozza;
        return (
          <li key={q.id}><Link to={`/offerte/${q.id}`} className="flex items-center gap-3 py-2.5 hover:bg-slate-50" data-testid={`quote-row-${q.id}`}>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-ink"><span className="font-mono text-xs text-slate-500">{q.number}{q.revision ? ` rev.${q.revision}` : ""}</span> · {q.title}</p>
              <p className="text-xs text-slate-500">{q.company_name ? `${q.company_name} · ` : ""}Validità {fmtDateLong(q.valid_until)}{q.expired && <span className="ml-1 font-semibold text-amber-700">· scaduta</span>}</p>
            </div>
            <span className="text-sm font-semibold text-ink" data-testid={`quote-taxable-${q.id}`}>{fmtCurrency(q.taxable)}<span className="ml-1 text-[11px] font-normal text-slate-400">+ IVA</span></span>
            {q.sign_pending && <StatusBadge tone="amber"><span className="inline-flex items-center gap-1" data-testid={`quote-sign-pending-${q.id}`}><PenLine className="h-3 w-3" /><span className="hidden sm:inline">In attesa di firma</span></span></StatusBadge>}
            <StatusBadge tone={st.tone}>{st.label}</StatusBadge>
          </Link></li>
        );
      })}
    </ul>
  )
);
